export default class UserService {
  baseUrl = process.env.REACT_APP__API_URL + '/share-api';

  async getMapData(secret: string): Promise<any> {
    return await (await fetch(`${this.baseUrl}/user/${secret}`)).json();
  }
}
